import React, { Component } from "react";
import _ from "lodash";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  WithStyles,
  createStyles,
  Typography,
  Button,
  Grid,
  CircularProgress,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import { MyPATCollapse, MyPATDialog, MyPATSelect } from "../../../../common";
import ChallengeItem from "./ChallengeItem";
import ViewChallengePopup from "./ViewChallengePopup";
import AddChallengePopup from "./AddChallengePopup";
import contentService from "../../../services/contentService";
import Challenge from "../../../types/ChallengeQuestion";
import Pagination from "../../../../common/Pagination";
import { toggleLicenseExpiredDialog, setLoggedInUser } from "../../../../login/actions/userActions";
import contentRequestServices from "../../../../content-request/services/contentRequestServices";
import courseService from "../../../../course/services/courseService";

const styles = (theme: Theme) =>
  createStyles({
    challengeQuestionButton: {
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: "22px",
      Border: "solid 1px #1D7DEA",
      // width: "216px",
      height: "36px",
      letterSpacing: "0.5px",
      textAlign: "center",
      marginBottom: "8px",
    },
    imgCenter: {
      textAlign: "center",
      margin: "24px 0 0 0",
    },
    headingtxt: {
      fontSize: "1.25rem",
      color: "#333",
      lineHeight: "24px",
      margin: "24px 0 12px 0",
      textAlign: "center",
    },
    subheading: {
      fontSize: "16px",
      color: "#999",
      lineHeight: "130%",
      textAlign: "center",
      margin: "0px 10px 23px 10px",
    },
    challangeCard: {
      backgroundColor: "#fff",
      border: "1px solid rgba(153, 153, 153, 0.4)",
      borderRadius: "4px",
      margin: "4px",
      padding: "0 0 16px 0",
    },
    txtCenter: {
      textAlign: "center",
    },
    txtRight: {
      textAlign: "right",
    },
    title: {
      color: "rgb(51 51 51)",
      margin: "0",
      fontSize: "20px",
      fontStyle: "normal",
      fontWeight: 600,
    },
    noChallengeContainer: {
      margin: "36px 0",
      textAlign: "center",
      "& h5": { marginTop: "12px", fontSize: "1.25rem" },
      "& p": { color: "#999", fontSize: "1rem" },
    },
    // Tabs
    tabsCard: {
      marginTop: "13px",
      margin: "4px",
      // maxHeight: '60vh',
      // maxWidth: '97%'
    },
    tabContainer: {
      border: "1px solid rgba(153, 153, 153, 0.4)",
      borderRadius: "4px",
      padding: "0",
      boxSizing: "border-box",
      margin: "-2px",
      '&>:first-child':{
        '&>:first-child':{
          borderTopLeftRadius: 4,
          borderBottomLeftRadius: 4,
        }
      },
      '&>:nth-child(2)':{
        '&>:first-child':{
          borderTopRightRadius: 4,
          borderBottomRightRadius: 4,
        }
      }
    },
    challangetabs: {
      padding: "5px",
      margin: '0 5px',
      fontSize: "14px",
      lineHeight: "19px",
      fontFamily: "Nunito",
      textAlign: "center",
      cursor: "pointer",
      textTransform: "capitalize",
    },
    tabsInactive: {
      color: "#999",
      border: "1px solid #999",
    },
    tabsActive: {
      border: "1px solid #1d7dea",
      fontWeight: 600,
      color: "#1d7dea",
    },
    //dropdown menu
    dropDownPos: {
      position: "relative",
      '&>:first-child':{
        minWidth: 'auto!important',
        marginRight: 15,
      },
      '& select':{
        fontSize: 14,
        fontWeight: 'normal',
        paddingRight: 20,
      }
    },
    dropDownList: {
      fontSize: "16px",
      lineHeight: "22px",
      color: "#666",
      fontWeight: "normal",
      zIndex: 2,
      cursor: "pointer",
    },
    dropDownContent: {
      position: "absolute",
      top: "40px",
      right: "0",
      zIndex: 9,
      boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.12)",
      backgroundColor: "#fff",
      padding: "5px",
      "&::before": {
        content: '" "',
        backgroundColor: "transparent",
        borderRight: "8px solid transparent",
        borderLeft: "8px solid transparent",
        borderBottom: "8px solid #fff",
        position: "absolute",
        top: "-8px",
        right: "18px",
        zIndex: 9,
        width: "0px",
        height: "0px",
        display: "block",
      },
      "&::after": {
        content: '" "',
        backgroundColor: "transparent",
      },
    },
    dropDownitem: {
      display: "block",
      width: "110px",
      padding: "5px 10px",
      fontSize: "14px",
      lineHeight: "150%",
      color: "#666",
      fontWeight: "normal",
      "&:hover": {
        backgroundColor: "#f1f1f1",
        cursor: "pointer",
      },
    },
    inputClass: {
      border: 'none'
    },
    challengeRight:{
      width: '100%',
      maxHeight: '70vh',
      '&>:first-child':{
        width: '100%',
        paddingBottom: '100px',
      }
    },
    paginationContainer:{
      '&>div:nth-of-type(1)':{
        justifyContent: 'center',
      }
    }
  });

interface ChallengeQuestionProps extends WithStyles<typeof styles> {
  isCreatedByLoggedInUser: boolean;
  questionId?: string;
  authUser: any;
  acceptChallengeHandler: () => void;
  isPostExpiryDays: any,
  showLicenseExpiredDialog: any,
  toggleLicenseExpiredDialog: any,
  setLoggedInUser: any,
  questionDetails: string,
}

enum ChallengeModals {
  ADD_CHALLENGE,
  VIEW_CHALLENGE,
}

enum ChallengeCreators {
  AUTHOR = "author",
  STUDENT = "student",
  ALL = 'all'
}

enum ChallengeStatus {
  OPEN = "open",
  ACCEPTED = "accepted",
  DISMISSED = "dismissed",
  RESOLVED = "resolved",
}

interface ChallengeQuestionState {
  currentlyOpenedModal: ChallengeModals | null;
  activeTab: ChallengeCreators;
  activeChallengeStatus: ChallengeStatus;
  viewChallengeIndex: number;
  contentId: string;
  author: {
    challenges: Challenge[];
    totalChallenges: number;
    isFetchingChallenges: boolean;
    numberOfPages: number;
  };
  student: {
    challenges: Challenge[];
    totalChallenges: number;
    isFetchingChallenges: boolean;
    numberOfPages: number;
  };
  all: {
    challenges: Challenge[];
    totalChallenges: number;
    isFetchingChallenges: boolean;
    numberOfPages: number;
  };
}

class ChallengeQuestion extends Component<
  ChallengeQuestionProps,
  ChallengeQuestionState
> {
  constructor(props: ChallengeQuestionProps) {
    super(props);
    this.state = {
      currentlyOpenedModal: null,
      activeTab: ChallengeCreators.ALL,
      activeChallengeStatus: ChallengeStatus.OPEN,
      viewChallengeIndex: -1,
      contentId: '',
      author: {
        challenges: [],
        totalChallenges: 0,
        isFetchingChallenges: false,
        numberOfPages: 0,
      },
      student: {
        challenges: [],
        totalChallenges: 0,
        isFetchingChallenges: false,
        numberOfPages: 0,
      },
      all: {
        challenges: [],
        totalChallenges: 0,
        isFetchingChallenges: false,
        numberOfPages: 0,
      },
    };
  }

  componentDidMount() {
    const { questionId, isCreatedByLoggedInUser,authUser } = this.props;
    if (questionId) {
      this.fetchChallenges(ChallengeCreators.AUTHOR, ChallengeStatus.OPEN);
      this.fetchChallenges(ChallengeCreators.STUDENT, ChallengeStatus.OPEN);
      this.fetchChallenges(ChallengeCreators.ALL, ChallengeStatus.OPEN);
 
      courseService.getContentDetails(this.props.questionDetails).then((res) => {
        this.setState({ contentId : res.contentId });
      });
    }

    this.props.setLoggedInUser();
  }

  componentDidUpdate(
    prevProps: ChallengeQuestionProps,
    prevState: ChallengeQuestionState
  ) {
    const requiresFetchingChallenges =
      prevState.activeChallengeStatus !== this.state.activeChallengeStatus;
    if (requiresFetchingChallenges) {
      const { activeChallengeStatus } = this.state;
      this.fetchChallenges(ChallengeCreators.AUTHOR, activeChallengeStatus);
      this.fetchChallenges(ChallengeCreators.STUDENT, activeChallengeStatus);
      this.fetchChallenges(ChallengeCreators.ALL, activeChallengeStatus);
    }
  }

  fetchChallenges = async (
    tab: ChallengeCreators,
    status: ChallengeStatus,
    pageNumber?: number
  ) => {
    const { questionId,isCreatedByLoggedInUser,authUser } = this.props;
    try {
      if (!questionId) {
        return;
      }
      this.setState((prevState) => ({
        ...prevState,
        [tab]: { ...prevState[tab], isFetchingChallenges: true },
      }));
      const params:any={
        questionId,
        reviewerType: tab,
        reviewStatus: status,
        pageNumber,
      }
      if(!isCreatedByLoggedInUser){
        params.reviewerId=authUser._id;
        // params.reviewStatus=ChallengeStatus.OPEN;
        params.reviewerType='all'
      }
      const data = await contentService.getQuestionReviews(params);
      if (data) {
        const { questionReviews = [] } = data;
        this.setState((prevState) => {
          const totalChallenges = _.get(
            data,
            "totalRecords",
            prevState[tab].totalChallenges
          );
          const numberOfPages = _.get(
            data,
            "numberOfPages",
            prevState[tab].numberOfPages
          );
          return {
            ...prevState,
            [tab]: {
              ...prevState[tab],
              challenges: questionReviews,
              totalChallenges,
              isFetchingChallenges: false,
              numberOfPages,
            },
          };
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  handleDialogClose = () => {
    this.setState({
      currentlyOpenedModal: null,
      viewChallengeIndex: -1,
    });
  };
  openAddChallengeQuestionModal = () => {
    if (this.props.isPostExpiryDays) {
      this.props.toggleLicenseExpiredDialog(true);
    } else {
      this.setState({
        currentlyOpenedModal: ChallengeModals.ADD_CHALLENGE,
      });
    }
  };
  openViewChallengeModal = (index: number) => {
    this.setState({
      currentlyOpenedModal: ChallengeModals.VIEW_CHALLENGE,
      viewChallengeIndex: index,
    });
  };

  modifyChallengeStatus = (
    questionChallengeId: string,
    status: ChallengeStatus
  ) => {
    this.setState((prevState) => {
      const { activeTab } = prevState;
      const challenges = prevState[activeTab].challenges.map((challenge) => {
        const newChallenge = { ...challenge };
        if (newChallenge._id === questionChallengeId) {
          newChallenge.status = status;
        }
        return newChallenge;
      });
      return {
        ...prevState,
        [activeTab]: {
          ...prevState[activeTab],
          challenges,
        },
      };
    });
  };

  onDismiss = async (questionChallengeId: string) => {
    try {
      // Set status of the challenge to dismissed optimistically
      this.modifyChallengeStatus(
        questionChallengeId,
        ChallengeStatus.DISMISSED
      );
      await contentService.updateQuestionReviewStatus({
        questionReviewId: questionChallengeId,
        reviewStatus: ChallengeStatus.DISMISSED,
      });
    } catch (error) {
      console.log(error);
    }
  };

  onAccept = async (questionChallengeId: string) => {
    try {
      // Set status of the challenge to accepted optimistically
      this.modifyChallengeStatus(questionChallengeId, ChallengeStatus.ACCEPTED);

      await contentService.updateQuestionReviewStatus({
        questionReviewId: questionChallengeId,
        reviewStatus: ChallengeStatus.ACCEPTED,
      });
      // Redirect to Edit questions
      this.props.acceptChallengeHandler();
    } catch (error) {
      console.log(error);
    }
  };

  getTabStateClasses = (tab: ChallengeCreators) => {
    const { classes } = this.props;
    return this.state.activeTab === tab
      ? classes.tabsActive
      : classes.tabsInactive;
  };

  setCurrentlyActiveTab = (tab: ChallengeCreators) => {
    this.setState({
      activeTab: tab,
    });
  };

  setActiveChallengeStatus = (e: any) => {
    e.stopPropagation();
    const status: ChallengeStatus = e.target.value;
    this.setState({
      activeChallengeStatus: status,
    });
  };

  renderChallengeQuestionSection = () => {
    const { classes } = this.props;
    return (
      <Grid className={classes.challangeCard}>
        <Grid container direction="row" justify="center" alignItems="center">
          <Grid item>
            <div className={classes.imgCenter}>
              <img src="/assets/svg/myLibrary/something-wrong.svg" />
            </div>
            <Typography className={classes.headingtxt}>
              Found something wrong?
            </Typography>
            <Typography className={classes.subheading}>
              You can always challenge the Question and report it to the content
              author if you think something is wrong
            </Typography>
          </Grid>
        </Grid>
        <div className={classes.txtCenter}>
          <Button
            className={classes.challengeQuestionButton}
            autoFocus
            variant="outlined"
            color="primary"
            onClick={this.openAddChallengeQuestionModal}
          >
            Challenge Question
          </Button>
        </div>
      </Grid>
    );
  };

  render() {
    const {
      classes,
      isCreatedByLoggedInUser,
      authUser,
      questionId,
    } = this.props;
    const {
      currentlyOpenedModal,
      viewChallengeIndex,
      activeTab,
      activeChallengeStatus,
    } = this.state;
    const { challenges, isFetchingChallenges, numberOfPages } = this.state[
      activeTab
    ];
    return (
      <>
        {/* <MyPATCollapse
          title={
            <Grid container justify="space-between">
              <Grid item>
                <Typography className={classes.title}>
                  <span>Challenges</span>
                </Typography>
              </Grid>
              {isCreatedByLoggedInUser && (
                <Grid item className={classes.dropDownPos}>
                  <MyPATSelect
                    label=""
                    inputId="challengeQuestionFilter"
                    name="challengeQuestionFilter"
                    defaultValue={ChallengeStatus.OPEN}
                    value={activeChallengeStatus}
                    onChange={this.setActiveChallengeStatus}
                    onFocus={(e: any) => e.stopPropagation()}
                    onClick={(e: any) => e.stopPropagation()}
                    onBlur={(e: any) => e.stopPropagation()}
                    inputClass={classes.inputClass}
                  >
                    <option value={ChallengeStatus.OPEN}>Open</option>
                    <option value={ChallengeStatus.ACCEPTED}>Accepted</option>
                    <option value={ChallengeStatus.DISMISSED}>Dismissed</option>
                  </MyPATSelect>
                  {/* <span className={classes.dropDownList}>
                    Open <img src="/assets/svg/myLibrary/chevron-down.svg" />
                  </span> */}
                  {/* <span className={classes.dropDownContent}>
                  <span className={classes.dropDownitem}>Value 1</span>
                  <span className={classes.dropDownitem}>Value 2</span>
                  <span className={classes.dropDownitem}>Value 3</span>
                </span> */}
                {/* </Grid> */}
              {/* )} */}
            {/* </Grid> */}
          {/* } */}
        {/* > */}

            <Grid container className={classes.challengeRight}>
            {/* <PerfectScrollbar> */}
            <Grid className={classes.tabsCard}>
                <Grid container justify="flex-start" alignItems="center">
                <Grid item xs className={classes.dropDownPos}>
                  <MyPATSelect
                    label=""
                    inputId="challengeQuestionFilter"
                    name="challengeQuestionFilter"
                    defaultValue={ChallengeStatus.OPEN}
                    value={activeChallengeStatus}
                    onChange={this.setActiveChallengeStatus}
                    onFocus={(e: any) => e.stopPropagation()}
                    onClick={(e: any) => e.stopPropagation()}
                    onBlur={(e: any) => e.stopPropagation()}
                    inputClass={classes.inputClass}
                  >
                    <option value={ChallengeStatus.OPEN}>Open</option>
                    <option value={ChallengeStatus.ACCEPTED}>Accepted</option>
                    <option value={ChallengeStatus.DISMISSED}>Dismissed</option>
                    <option value={ChallengeStatus.RESOLVED}>Resolved</option>
                  </MyPATSelect>
                </Grid>


                {/*@forntend "tabsInactive" class for InActive Tab and "tabsActive" class for Active Tab */}
               {isCreatedByLoggedInUser&& <> <Grid item xs="auto">By: </Grid>
               <Grid item xs="auto">
                  <span
                    onClick={() =>
                      this.setCurrentlyActiveTab(ChallengeCreators.ALL)
                    }
                    className={[
                      classes.challangetabs,
                      this.getTabStateClasses(ChallengeCreators.ALL),
                    ].join(" ")}
                  >
                    All
                  </span>
                </Grid>
                <Grid item xs="auto">
                  <span
                    onClick={() =>
                      this.setCurrentlyActiveTab(ChallengeCreators.AUTHOR)
                    }
                    className={[
                      classes.challangetabs,
                      this.getTabStateClasses(ChallengeCreators.AUTHOR),
                    ].join(" ")}
                  >
                    Author
                  </span>
                </Grid>
                <Grid item xs="auto">
                  <span
                    onClick={() =>
                      this.setCurrentlyActiveTab(ChallengeCreators.STUDENT)
                    }
                    className={[
                      classes.challangetabs,
                      this.getTabStateClasses(ChallengeCreators.STUDENT),
                    ].join(" ")}
                  >
                    Student
                  </span>
                </Grid>

              </>}
              {!isCreatedByLoggedInUser &&
                challenges.length>0 &&
                <Grid item xs='auto'>
                 <div className={classes.txtCenter}>
                  <Button
                    className={classes.challengeQuestionButton}
                    autoFocus
                    variant="outlined"
                    color="primary"
                    onClick={this.openAddChallengeQuestionModal}
                  >
                    Challenge
                  </Button>
                </div>
                </Grid>
               }
              </Grid>
              {/* Card info */}
              {isFetchingChallenges && (
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                  <CircularProgress />
                </div>
              )}
              {!isFetchingChallenges &&
                challenges.map((challenge, i) => {
                  return (
                    <ChallengeItem
                      key={i}
                      data={challenge}
                      viewIndex={i}
                      onDismiss={this.onDismiss}
                      onAccept={this.onAccept}
                      onViewFull={this.openViewChallengeModal}
                      isCreatedByLoggedInUser={isCreatedByLoggedInUser}
                    />
                  );
                })}
              {!isFetchingChallenges && challenges.length === 0 && (
               <>{isCreatedByLoggedInUser ?
                <div className={classes.noChallengeContainer}>
                  <img
                    src="/assets/svg/emptyChallengeList.svg"
                    alt="No challenges"
                  />
                  <Typography gutterBottom variant="h5">
                    No challenges received yet
                  </Typography>
                  <Typography gutterBottom>
                    Challenges will be listed here once someone post them
                  </Typography>
                </div>
              :
              <>{this.renderChallengeQuestionSection()}</>
              }
              </>)}
              {numberOfPages > 0 && (
              <Grid className={classes.paginationContainer}>
                <Pagination
                  key={activeTab}
                  totalPages={numberOfPages}
                  onPageChange={(pageNumber: number) =>
                    this.fetchChallenges(
                      activeTab,
                      activeChallengeStatus,
                      pageNumber
                    )
                  }
                />
              </Grid>
              )}
              {/* View challange */}
              {currentlyOpenedModal === ChallengeModals.VIEW_CHALLENGE && (
                <ViewChallengePopup
                  open={currentlyOpenedModal === ChallengeModals.VIEW_CHALLENGE}
                  data={challenges[viewChallengeIndex]}
                  onDismiss={this.onDismiss}
                  onAccept={this.onAccept}
                  onClose={this.handleDialogClose}
                  contentId={this.state.contentId}
                />
              )}
              {/* Are you sure popup */}
            </Grid>
            {/* </PerfectScrollbar> */}
            </Grid>
        {/* </MyPATCollapse> */}

        {!isCreatedByLoggedInUser &&
          currentlyOpenedModal === ChallengeModals.ADD_CHALLENGE && (
            <AddChallengePopup
              open={currentlyOpenedModal === ChallengeModals.ADD_CHALLENGE}
              onClose={this.handleDialogClose}
              onDone={this.handleDialogClose}
              authUser={authUser}
              questionId={questionId}
            />
          )}
      </>
    );
  }
}

const mapStateToProps = (state: any) => ({
  showLicenseExpiredDialog:  state.loginData.userData &&  state.loginData.userData.showLicenseExpiredDialog,
  isPostExpiryDays:  state.loginData.userData &&  state.loginData.userData.isPostExpiryDays,
  authUser: _.get(state, 'loginData.userData.authenticatedUser'),
  });

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
  toggleLicenseExpiredDialog,
  setLoggedInUser
}, dispatch);

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ChallengeQuestion));
